// Pure class composition for <IconButton> — variant × tone × size, the same house grammar as
// Button (color via the .rc-tone-* slots in tones.css). Split out for unit testing.
import { cn } from "./cn";
import type { Tone } from "./tone";

export type IconButtonVariant = "solid" | "soft" | "outline" | "ghost";
export type IconButtonTone = Tone;
export type IconButtonSize = "sm" | "md" | "lg";

export function iconButtonClass(
  variant: IconButtonVariant,
  tone: IconButtonTone,
  size: IconButtonSize,
  extra?: string,
): string {
  return cn(
    "rc-icon-button",
    `rc-icon-button--${variant}`,
    `rc-tone-${tone}`,
    `rc-icon-button--${size}`,
    extra,
  );
}
